export default function B2BPurchasesPage() {
    return (
        <div style={{width: '100%'}}>
            <h1 className="h1-title" style={{textAlign: 'center'}}>Ведутся технические работы</h1>
            <img style={{width: '100%'}} src={require("../images/tech.png")} alt="tech"></img>
        </div>)
}